import { PractitionerNote } from '@repo/types';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { API } from 'api';

import { apiBasePath, apiName } from 'assets/constants';
import { PRACTITIONER_NOTE_QUERY_KEY } from './constants';

const getPractitionerNote = async (
  kitId: string,
): Promise<PractitionerNote | null> => {
  if (!kitId) return null;

  const response = await API.get(
    apiName,
    `${apiBasePath}/practitioner-notes/${kitId}`,
    {},
  );

  return response ?? null;
};

// Here we get the note for the practitioner during impersonation (maybe not published yet)
export function useGetPractitionerNote(kitId: string | null) {
  return useQuery({
    queryKey: ['practitioner-note', kitId],
    queryFn: () => getPractitionerNote(kitId!),
    enabled: !!kitId,
  });
}

const upsertPractitionerNote = async (
  kitId: string,
  data: Partial<PractitionerNote>,
): Promise<PractitionerNote> => {
  const response = await API.put(
    apiName,
    `${apiBasePath}/practitioner-notes/${kitId}`,
    data,
  );

  return response;
};

export function useUpsertPractitionerNote(
  kitId: string | null,
  onSuccess?: () => void,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: Partial<PractitionerNote>) =>
      upsertPractitionerNote(kitId!, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [PRACTITIONER_NOTE_QUERY_KEY, kitId],
      });
      onSuccess?.();
    },
  });
}
